import Lightbox from 'root/helpers/lightbox';

export function handleYoutubeLightboxesOnDocumentClick() {
    return (function () {
        document.addEventListener('click', handleClickEvent);

        let ltbx;
        const iframe = document.createElement('iframe');
        iframe.setAttribute('allowfullscreen', true);
        iframe.setAttribute('frameborder', 0);
        iframe.setAttribute('allow', 'autoplay');
        iframe.setAttribute('onload', 'this.contentWindow.focus()');

        function handleClickEvent(event) {
            const closestVideo = event.target?.closest('[data-ls-youtube]');
            if (closestVideo) {
                const videoId = closestVideo.dataset.lsYoutube;
                const videoLink = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&enablejsapi=1`;
                iframe.setAttribute('class', 'optanon-category-C0001'); // important for the iframe not to be blocked by OneTrust autoblocking
                iframe.src = videoLink;
                if (typeof ltbx === 'undefined') {
                    ltbx = new Lightbox(iframe, {
                        name: 'ls-youtube',
                        visibilityClass: 'lightbox-visible-media',
                        onHideCallback: function () {
                            iframe.src = '';
                        },
                        onShowCallback: function () {
                            if (iframe.src === '') {
                                iframe.src = videoLink;
                            }
                        },
                    });
                    ltbx.init();
                } else {
                    ltbx.show();
                }
            }
        }
    })();
}
